import React, { useEffect, useMemo } from "react"
import { Select, message } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { fetchCountries } from "src/redux/countrySlice"

const removeVietnameseTones = str =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase()

const SelectCountry = React.memo(
  ({ value, onChange, disabled, style = { height: "36px" }, type }) => {
    const dispatch = useDispatch()
    const countries = useSelector(
      state => state.country.dataByType?.[type] || [],
    )

    useEffect(() => {
      if (!countries.length) {
        dispatch(fetchCountries(type))
          .unwrap()
          .catch(err => {
            // message.error("Không thể lấy danh sách quốc gia")
            console.error("Lỗi lấy quốc gia:", err)
          })
      }
    }, [type])

    const countryOptions = useMemo(() => {
      return countries.map(country => (
        <Select.Option key={country.ID} value={country.ID}>
          {country.title}
        </Select.Option>
      ))
    }, [countries])

    const filterOption = useMemo(() => {
      return (input, option) => {
        const inputNormalized = removeVietnameseTones(input)
        const optionText = removeVietnameseTones(option.children)
        return optionText.includes(inputNormalized)
      }
    }, [])

    return (
      <Select
        placeholder="Chọn quốc gia"
        title="Chọn quốc gia"
        allowClear
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={style}
        showSearch
        filterOption={filterOption}
      >
        {countryOptions}
      </Select>
    )
  },
)

export default SelectCountry
